'use strict';

angular.module('invitations')
    .factory('InvitationsManager', ['$q', 'ShareCrfSDK', 'Event', function($q, ShareCrfSDK, Event) {
        var initied = false;
        var loadPromise = null;

        var serviceData = {
            studiesInfo: {},
            userInvitations: [],
        };

        var InvitationsManager = {};

        /**
         * Init
         *
         * @return {Promise} -
         */
        InvitationsManager.init = function StudiesManagerInit() {
            var promise;

            if (initied) {
                promise = $q.resolve();
            }
            else if (loadPromise) {
                promise = loadPromise;
            }
            else {
                loadPromise = InvitationsManager.loadUserInvitations()
                    .then(function(response) {
                        Array.prototype.push.apply(serviceData.userInvitations, response.data);
                        initied = true;

                        loadPromise = null;
                    });

                promise = loadPromise;
            }

            return promise;
        };

        /**
         * Init
         *
         * @return {Promise} -
         */
        InvitationsManager.reload = function StudiesManagerReload() {
            var promise;

            if (!initied) {
                promise = InvitationsManager.init();
            }
            else if (loadPromise) {
                promise = loadPromise;
            }
            else {
                loadPromise = InvitationsManager.loadUserInvitations()
                    .then(function(response) {
                        _.remove(serviceData.userInvitations);
                        Array.prototype.push.apply(serviceData.userInvitations, response.data);

                        loadPromise = null;
                    });

                promise = loadPromise;
            }

            return promise;
        };

        /**
         * Load data from server
         *
         * @return {Promise<Object>} Data and counter
         */
        InvitationsManager.loadUserInvitations = function() {
            return ShareCrfSDK.portal.invitations
                .getLoggedUserInvitations({
                    fields: 'code,content,createdAt',
                    filters: 'status eq \'pending\'',
                    expand: 'study($select=subdomain;$filter=status eq \'open\')',
                    order: 'createdAt desc',
                });
        };

        /**
         * Get list
         *
         * @return {Array<Object>} Invitations
         */
        InvitationsManager.getUserInvitations = function() {
            return serviceData.userInvitations;
        };

        InvitationsManager.getStudyInfo = function(studySubdomain) {
            var promise;

            if (serviceData.studiesInfo[studySubdomain]) {
                promise = $q.resolve(serviceData.studiesInfo[studySubdomain]);
            } else {
                promise = ShareCrfSDK.info.getStudy(studySubdomain)
                    .then(function(studyInfo) {
                        serviceData.studiesInfo[studySubdomain] = studyInfo;

                        return studyInfo;
                    });
            }

            return promise;
        };

        InvitationsManager.assignInvitationCode = function(invitationCode) {
            return ShareCrfSDK.portal.invitations.assign(invitationCode)
                .then(function() {
                    return Event.trigger('invitationAssigned');
                });
        };

        /**
         * Accept invitation
         *
         * @param {Invitation} invitation
         *
         * @return {Promise}
         */
        InvitationsManager.acceptInvitation = function(invitation) {
            return ShareCrfSDK.portal.invitations.accept(invitation.code)
                .then(function() {
                    return Event.trigger('invitationAccepted');
                });
        };

        /**
         * Reject invitation
         *
         * @param {Invitation} invitation
         *
         * @return {Promise}
         */
        InvitationsManager.rejectInvitation = function(invitation) {
            return ShareCrfSDK.portal.invitations.reject(invitation.code)
                .then(function() {
                    return Event.trigger('invitationRejected');
                });
        };

        /**
         * Clear data
         *
         * Registered in event 'logout'
         */
        InvitationsManager.clearData = function InvitationsManagerClearData() {
            initied = false;
            _.remove(serviceData.userInvitations);
            serviceData.studiesInfo = {};
        };

        /**
         * Check invitation for sign up
         *
         * @param {Integer} invitationId
         * @param {String} invitationCode
         *
         * @return {Promise<String>}
         */
        InvitationsManager.getInvitation = function(invitationCode) {
            return ShareCrfSDK.portal.invitations.load(invitationCode);
        };

        /**
         * Register event listeners
         */
        Event.on('logout', InvitationsManager.clearData);

        Event.on('invitationAccepted', InvitationsManager.reload);
        Event.on('invitationRejected', InvitationsManager.reload);
        Event.on('invitationAssigned', InvitationsManager.reload);

        return InvitationsManager;
    }]);
